var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"try-again-button"},[_c('div',[_vm._v(" Попробовать еще раз "),_c('InlineSvg',{attrs:{"src":require('@/assets/img/icons/repeat.svg')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }